import React from 'react'
import { cn } from '@kiao-voice/ui-kit'

/**
 * 三欄「小標＋一句說明」，每欄上緣一條線。淺底與墨底兩種 variant 只換顏色，
 * 尺寸完全一樣——同一個資訊密度在兩種底色上要讀起來是同一個東西。
 */

export interface FeatureTripletItem {
  title: string
  description: string
}

export interface FeatureTripletProps {
  items: FeatureTripletItem[]
  variant?: 'light' | 'ink'
  className?: string
}

export function FeatureTriplet({ items, variant = 'light', className }: FeatureTripletProps) {
  const ink = variant === 'ink'
  return (
    <div
      className={cn('grid grid-cols-3 gap-(--gap-lg) max-[920px]:grid-cols-1', className)}
    >
      {items.map((item) => (
        <div
          key={item.title}
          className={cn('border-t pt-4', ink ? 'border-inv-line' : 'border-border')}
        >
          <h3 className="mb-1.5 text-lg leading-[1.5] font-semibold">{item.title}</h3>
          <p className={cn('text-md leading-[1.65]', ink ? 'text-background/72' : 'text-muted')}>
            {item.description}
          </p>
        </div>
      ))}
    </div>
  )
}
